import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from "react-router-dom";
import Modal from "../../components/parent/Modal"
import API_ENDPOINTS from "../../utils/apiEndpoints";

const ParentInfo = () => {
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const { id } = useParams();

    const navigate = useNavigate();
    const fileInputPhotoRef = useRef(null);
    const fileInputDocumentsRef = useRef(null);

    const [classes, setClasses] = useState([]);
    const [casteCategory, setCasteCategory] = useState([]);
    const [languages, setlanguages] = useState([]);
    const [genders, setgenders] = useState([]);
    const [extra_curricular_activities, setextra_curricular_activities] = useState([]);
    const [countries, setcountries] = useState([]);
    const [co_curricular_activities, setco_curricular_activities] = useState([]);
    const [blood_groups, setblood_groups] = useState([]);
    const [boards, setboards] = useState([]);

    const [mediums, setmediums] = useState([]);
    const [board, setboard] = useState([])
    const [language, setlanguage] = useState([])
    const [extraCurricular, setextraCurricular] = useState([])





    const [checkboxes, setCheckboxes] = useState({
        termsChecked: false,
        privacyChecked: false
    });
    const [formData, setFormData] = useState({
        fatherName: '',
        fatherOccupation: '',
        motherName: '',
        motherOccupation: '',
        fatherAdhaarNo: '',
        motherAdhaarNo: '',
        email: '',
        parentAnnualIncome: '',

    });

    if (formData.siblingsinSSV === "no" || "") {
        formData.SiblingsData = ""
    }

    //     const downloadJSON = () => {
    //   const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(formData, null, 2));
    //   const anchor = document.createElement("a");
    //   anchor.href = dataStr;
    //   anchor.download = "data.json";
    //   document.body.appendChild(anchor);
    //   anchor.click();
    //   document.body.removeChild(anchor);
    // };



    const updatedPreviewData =
    {
        "Father's Name": formData.fatherName,
        "Father's Occupation": formData.fatherOccupation,
        "Mother's Name": formData.motherName,
        "Mother's Occupation": formData.motherOccupation,
        "Father's Aadhaar Number": formData.fatherAdhaarNo,
        "Mother's Aadhaar Number": formData.motherAdhaarNo,
        "Email": formData.email,
        "Parent Annual Income": formData.parentAnnualIncome
    }


    useEffect(() => {
        const token = localStorage.getItem("parentToken");

        if (!token) {
            console.error("No token found in localStorage");
            return;
        }

        fetch(API_ENDPOINTS.DROPDOWN_DATA, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        })
            .then(response => response.json())
            .then(data => {
                setClasses(data.data.classes);
                setmediums(data.data.mediums)
                setlanguage(data.data.languages)
                setboard(data.data.boards)
                setextraCurricular(data.data.extra_curricular_activities)
                setco_curricular_activities(data.data.co_curricular_activities)

            })
            .catch(error => console.error("Error fetching classes:", error));
    }, []);

    // useEffect(() => {
    //     // Include the Bearer token in the GET request
    //     axios.get('http://127.0.0.1:8000/api/classes', {
    //         headers: { Authorization: `Bearer ${localStorage.getItem('parentToken')}` }
    //     })

    //         .then(response => setClasses(response.data))
    //         .catch(error => console.error('Error fetching classes:', error));
    // }, []);

    const handleChange = (e) => {
        const value = e.target.value.replace(/[^\x00-\x7F]/g, '');
        setFormData({ ...formData, [e.target.name]: value });
    };

    const handleCoCurricularChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            co_curricular_activity_id: e.target.value, // Only one selection allowed
        }));
    };

    //    const downloadJsonFile = () => {
    //     const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(formData, null, 2));
    //     const downloadAnchor = document.createElement("a");
    //     downloadAnchor.href = dataStr;
    //     downloadAnchor.download = "formData.json";
    //     document.body.appendChild(downloadAnchor);
    //     downloadAnchor.click();
    //     document.body.removeChild(downloadAnchor);
    // };


    const handleSubmit = (e) => {
        // downloadJsonFile()
        e.preventDefault();
        setShowModal(true); // Open modal to preview data
    };


    // const handleFinalSubmit = async () => {
    //     try {
    //         const formDataObj = new FormData1();
    //         Object.keys(formData).forEach((key) => formDataObj.append(key, formData[key]));

    //         const response = await axios.post("http://127.0.0.1:8000/api/admission", formDataObj, {
    //             headers: { Authorization: `Bearer ${localStorage.getItem("parentToken")}` },
    //         });

    //         alert(response.data.message); // Show success message
    //         navigate("/parent-info");
    //         setShowModal(false); // Close modal
    //     } catch (error) {
    //         console.error("Error submitting form:", error);
    //     }
    // };
    const handleNestedChange = (e) => {
        const { name, value } = e.target;
        const sanitizedValue = value.replace(/[^\x00-\x7F]/g, '');

        setFormData((prev) => ({
            ...prev,
            lastAnnualExamMarks: {
                ...prev.lastAnnualExamMarks, // Keep existing nested data
                [name]: sanitizedValue,  // Update the specific nested field
            },
        }));
    };


    const handleFileChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.files[0] });
    };

    const handleMarksChange = (e) => {
        const { name, value } = e.target;
        const sanitizedValue = value.replace(/[^\x00-\x7F]/g, '');

        setFormData((prev) => ({
            ...prev,
            lastAnnualExamMarks: {
                ...prev.lastAnnualExamMarks,
                [name]: sanitizedValue, // Updates only marks
            },
        }));
    };


    const handleLanguageChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            lastAnnualExamMarks: {
                ...prev.lastAnnualExamMarks,
                language_id: e.target.value, // Updates only the Language field
            },
        }));
    };

    const handleHobbyChange = (e) => {
        const { value, checked } = e.target;
        const activityId = Number(value); // Convert value to number (if it's stored as a number in extraCurricular)

        setFormData((prev) => ({
            ...prev,
            extra_curricular_activity_id: checked
                ? [...prev.extra_curricular_activity_id, activityId] // Store only ID
                : prev.extra_curricular_activity_id.filter((id) => id !== activityId), // Remove ID if unchecked
        }));
    };




    // const handleFinalSubmit = async () => {
    //   navigate("/academic-info");
    //   setFormData({
    //     fatherName: '',
    //   fatherOccupation: '',
    //   motherName: '',
    //   motherOccupation: '',
    //   fatherAdhaarNo: '',
    //   motherAdhaarNo: '',
    //   email: '',
    //   parentAnnualIncome: '',
    //   })
    // //   try {
    // //     const mobile = 1234567899;
    // //     const response = await axios.post("http://127.0.0.1:8000/api/send-otp", { mobile });
    // //     // setOtpSent(true);
    // //     // setError("");
    // //     console.log(response.data.otp);
    // //     console.log(response);


    // // }catch (error) {
    // //         console.error("Error submitting form:", error);
    // //     }
    // };


    const handleFinalSubmit = async () => {
        const token = localStorage.getItem("parentToken");
        if (!token) {
            console.error("Authentication token is missing.");
            return;
        }

        setLoading(true); // Show "Saving..."

        const requestData = {
            student_id: Number(id),
            email: formData.email || "",
            father_name: formData.fatherName || "",
            father_occupation: formData.fatherOccupation || "",
            mother_name: formData.motherName || "",
            mother_occupation: formData.motherOccupation || "",
            father_adhaar_no: formData.fatherAdhaarNo || "",
            mother_adhaar_no: formData.motherAdhaarNo || "",
            parent_annual_income: formData.parentAnnualIncome || ""
        };



        // console.log(requestData);

        try {
            const response = await fetch(API_ENDPOINTS.PARENT_INFO, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();

            if (!response.ok || !result.success) {
                let errorMessage = result.message || "An error occurred.";
                if (result.data) {
                    errorMessage += "\n" + Object.values(result.data).flat().join("\n");
                }
                alert(errorMessage);
            } else {
                //   console.log("Success:", result);
                navigate(`/academic-info/${result.data.parentInfo
                    .id}`);
                setShowModal(false); // Close modal on success
                setFormData({
                    fatherName: '',
                    fatherOccupation: '',
                    motherName: '',
                    motherOccupation: '',
                    fatherAdhaarNo: '',
                    motherAdhaarNo: '',
                    email: '',
                    parentAnnualIncome: '',
                });
            }
        } catch (error) {
            console.error("Network Error:", error);
            alert("Network error. Please try again.");
        } finally {
            setLoading(false); // Stop loading
        }
    };

    return (
        <>
            {/* Preview Modal */}
            <Modal loading={loading} show={showModal} onClose={() => setShowModal(false)} formData={updatedPreviewData} onFinalSubmit={handleFinalSubmit} />


            <div className="w-full min-h-screen flex items-center justify-center bg-gray-50 px-4">
                <div className="w-full max-w-2xl bg-white rounded-lg shadow-md p-6">
                    <h2 className="text-xl font-semibold text-center mb-4">Parent Information</h2>
                    <form onSubmit={handleSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">



                        {/*  email */}
                        <div>
                            <label className="block text-sm font-medium text-gray-600">Email Id</label>
                            <input
                                type="email"
                                name="email"
                                placeholder="Enter Email Id"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        {/* father name */}
                        <div>
                            <label className="block text-sm font-medium text-gray-600">Father's Name</label>
                            <input
                                type="text"
                                name="fatherName"
                                placeholder="Enter Father's Name"
                                value={formData.fatherName}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        {/* father Occupation */}
                        <div>
                            <label className="block text-sm font-medium text-gray-600">Father's Occupation</label>
                            <input
                                type="text"
                                name="fatherOccupation"
                                placeholder="Enter Father's Occupation"
                                value={formData.fatherOccupation}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        {/* mother name */}
                        <div>
                            <label className="block text-sm font-medium text-gray-600">Mother's Name</label>
                            <input
                                type="text"
                                name="motherName"
                                placeholder="Enter Mother's Name"
                                value={formData.motherName}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>


                        {/* mother Occupation */}
                        <div>
                            <label className="block text-sm font-medium text-gray-600">Mother's Occupation</label>
                            <input
                                type="text"
                                name="motherOccupation"
                                placeholder="Enter Mother's Occupation"
                                value={formData.motherOccupation}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        {/* Father Adhaar Number */}
                        <div>
                            <label className="block text-sm font-medium text-gray-600">Father's Adhaar Number</label>
                            <input
                                type="number"
                                name="fatherAdhaarNo"
                                placeholder=""
                                value={formData.fatherAdhaarNo}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                title="Enter a valid 12-digit Aadhaar number"
                                pattern="\d{12}"
                            />
                        </div>

                        {/* Mother Adhaar Number */}
                        <div>
                            <label className="block text-sm font-medium text-gray-600">Mother's Adhaar Number</label>
                            <input
                                type="number"
                                name="motherAdhaarNo"
                                placeholder=""
                                value={formData.motherAdhaarNo}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                title="Enter a valid 12-digit Aadhaar number"
                                pattern="\d{12}"
                            />
                        </div>


                        {/* Parent's Annual Income */}
                        <div>
                            <label className="block text-sm font-medium text-gray-600">Parent's Annual Income
                            </label>
                            <input
                                type="number"
                                name="parentAnnualIncome"
                                placeholder=""
                                value={formData.parentAnnualIncome}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>


                        {/* Submit Button (Full Width) */}
                        <div className="sm:col-span-2">
                            <button
                                type="submit"
                                className="w-full bg-blue-500 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition duration-200"
                            >
                                Preview
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default ParentInfo;
